import { orbitvuBlock } from './scripts/orbitvuBlock'
import { blockAnimator } from './scripts/blockAnimator'
import { faqListControls, faqSearchFilter } from './scripts/faqComponent'
import { bannerSlider } from './scripts/bannerSlider'
import { headerMenu } from './scripts/headerMenu'
import { languageSwitcher } from './scripts/languageSwitcher'
import { globals } from '@/src/globals'
import * as styles from './styles/index.scss'
import { bannerSliderScroll } from './scripts/bannerSliderScroll'
import { smoothScrollLinks } from './scripts/smoothScrollLinks'
import { bannerSliderCountdowns } from './scripts/bannerSliderCountdowns'
import { axios_ecoMailSubscribes } from './scripts/axios_ecoMailSubscribe'
import { techSpecsManualSwitcher } from './scripts/techSpecsManualSwitcher'
import { contentDuosWide_orbitvuResizer } from './scripts/contentDuosWide_orbitvuResizer'

// Main file
const ksystem = (input: any): void => {
  const processedStyles = styles

  globals.externalInput = input

  headerMenu()
  languageSwitcher()
  bannerSlider()
  bannerSliderScroll()
  faqListControls()
  faqSearchFilter()
  smoothScrollLinks()
  blockAnimator()
  bannerSliderCountdowns()
  axios_ecoMailSubscribes()
  techSpecsManualSwitcher()
  contentDuosWide_orbitvuResizer()
  orbitvuBlock()
}

export default ksystem
